var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import { ReferenceDataService } from '@/services/reference-data-service';
import { UserPreferenceService } from '@/services/user-preference-service';
import { TYPES } from '@/dependency-injection/types';
import { lazyInject } from '@/dependency-injection';
var FilterSidesheetMixin = /** @class */ (function (_super) {
    __extends(FilterSidesheetMixin, _super);
    function FilterSidesheetMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        return _this;
    }
    /**
     * Set the items to include deleted
     * @param includeDeleted Include deleted items
     */
    FilterSidesheetMixin.prototype.setIncludeDeleted = function (includeDeleted) {
        this.loading = true;
        this.store.items.setIncludeDeletedFilter(includeDeleted);
        this.store.managementPage.closeFilterSidesheet();
        this.loading = false;
    };
    Object.defineProperty(FilterSidesheetMixin.prototype, "loading", {
        /**
         * Global loading indicator
         */
        get: function () {
            return this.store.loading;
        },
        /**
         * Set the global loading indicator
         */
        set: function (loading) {
            this.store.setLoading(loading);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterSidesheetMixin.prototype, "visible", {
        /**
         * If the side sheet is visible
         */
        get: function () {
            return this.store.managementPage.filterSidesheetVisible;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Close the filter side sheet
     */
    FilterSidesheetMixin.prototype.close = function () {
        this.store.managementPage.closeFilterSidesheet();
    };
    var _a, _b;
    __decorate([
        lazyInject(TYPES.ReferenceDataService),
        __metadata("design:type", typeof (_a = typeof ReferenceDataService !== "undefined" && ReferenceDataService) === "function" ? _a : Object)
    ], FilterSidesheetMixin.prototype, "referenceDataService", void 0);
    __decorate([
        lazyInject(TYPES.UserPreferenceService),
        __metadata("design:type", typeof (_b = typeof UserPreferenceService !== "undefined" && UserPreferenceService) === "function" ? _b : Object)
    ], FilterSidesheetMixin.prototype, "userPreferenceService", void 0);
    FilterSidesheetMixin = __decorate([
        Component
    ], FilterSidesheetMixin);
    return FilterSidesheetMixin;
}(Vue));
export default FilterSidesheetMixin;
